import { render, staticRenderFns } from "./DictionaryMaintenance.vue?vue&type=template&id=4262356a"
import script from "./DictionaryMaintenance.vue?vue&type=script&lang=js"
export * from "./DictionaryMaintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports